import api from "../utils/axios/axiosConfig";

const creditAccountHistoryService = {
  get: (id) => api.get(`/credit-accounts-history/get/${id}`),
  getUserTransactions: (params) => api.post("/credit-accounts-history/get-user-transactions", params),
  search: (params) => api.post("/credit-accounts-history/search", params),
  updateStatus: (data) => api.put("/credit-accounts-history/update-status", data),
  getStats: (userId) => api.get(`/credit-accounts-history/stats${userId ? `/${userId}` : ""}`),
  getAuditTrail: (transactionId) => api.get(`/credit-accounts-history/audit/${transactionId}`),
};

export default creditAccountHistoryService;
